import { gql } from '@apollo/client';

// Apple Pay web merchant validation (own-certificate setup, CPS-26590):
// exchanges Safari's validationURL (+ the page's domain) for Apple's merchant
// session via BFF → payment service → Apple (merchant-identity mTLS). The
// merchantSession JSON is opaque — passed straight to
// ApplePaySession.completeMerchantValidation.
export const ADYEN_APPLE_PAY_MERCHANT_SESSION = gql`
  mutation AdyenApplePayMerchantSession(
    $input: AdyenApplePayMerchantSessionInput!
  ) {
    adyenApplePayMerchantSession(input: $input) {
      merchantSession
    }
  }
`;
